type OldCameraFormat = {
  value: number;
  label: string;
  labelFoxeer: string;
  labelVertex: string;
};
export const videoFormats: OldCameraFormat[] = [
  {
    value: 0,
    label: '2k7 48Hz 16:9 medium',
    labelFoxeer: '4k 30Hz 16:9 narrow',
    labelVertex: '4k 30Hz 16:9 normal',
  },
  {
    value: 2,
    label: '2k7 48Hz 16:9 medium',
    labelFoxeer: '2704*2028 30Hz 4:3, wide',
    labelVertex: '2k7 60Hz 16:9 normal',
  },
  {
    value: 4,
    label: '2k7 30Hz 16:9 wide',
    labelFoxeer: '2k7 30Hz 16:9, narrow',
    labelVertex: '2k7 30Hz 16:9 normal',
  },
  {
    value: 6,
    label: '2k7 30Hz 16:9 medium',
    labelFoxeer: '2k7 30Hz 16:9, narrow',
    labelVertex: '2k7 30Hz 16:9 normal',
  },
  {
    value: 8,
    label: '2k7 30Hz 16:9 linear',
    labelFoxeer: '2k7 30Hz 16:9, narrow',
    labelVertex: '2k7 30Hz 16:9 normal',
  },
  {
    value: 10,
    label: '2k7 30Hz 16:9 superview',
    labelFoxeer: '2k7 30Hz 16:9, wide',
    labelVertex: '2k7 60Hz 16:9 superview',
  },
  {
    value: 12,
    label: '2k7 24Hz 16:9 wide',
    labelFoxeer: '2k7 30Hz 16:9, narrow',
    labelVertex: '2k7 30Hz 16:9 normal',
  },
  {
    value: 14,
    label: '2k7 24Hz 16:9 medium',
    labelFoxeer: '2k7 30Hz 16:9, narrow',
    labelVertex: '2k7 30Hz 16:9 normal',
  },
  {
    value: 16,
    label: '2k7 30Hz 16:9 linear',
    labelFoxeer: '2k7 30Hz 16:9, narrow',
    labelVertex: '2k7 30Hz 16:9 normal',
  },
  {
    value: 18,
    label: '2k7 24Hz 16:9 superview',
    labelFoxeer: '2k7 30Hz 16:9, wide',
    labelVertex: '2k7 60Hz 16:9 superview',
  },
  {
    value: 20,
    label: '2k7 30Hz 4:3 wide',
    labelFoxeer: '2704*2028, 30Hz 4:3, wide',
    labelVertex: '2k7 30Hz 16:9 normal',
  },
  {
    value: 22,
    label: '1440p 60Hz 4:3 wide',
    labelFoxeer: '1920*1440 60Hz 4:3, wide',
    labelVertex: '2k7 60Hz 16:9 normal',
  },
  {
    value: 24,
    label: '1440p 48Hz 4:3 wide',
    labelFoxeer: '1920*1440 60Hz 4:3, wide',
    labelVertex: '2k7 60Hz 16:9 normal',
  },
  {
    value: 26,
    label: '1440p 30Hz 4:3 wide',
    labelFoxeer: '1920*1440 30Hz 4:3, wide',
    labelVertex: '2k7 30Hz 16:9 normal',
  },
  {
    value: 28,
    label: '1440p 24Hz 4:3 wide',
    labelFoxeer: '1920*1440 30Hz 4:3, wide',
    labelVertex: '2k7 30Hz 16:9 normal',
  },
  {
    value: 30,
    label: '1080p 90Hz 16:9 wide',
    labelFoxeer: '1080p 120Hz 16:9, narrow',
    labelVertex: '1080p 60Hz 16:9 normal',
  },
  {
    value: 32,
    label: '1080p 60Hz 16:9 wide',
    labelFoxeer: '1080p 60Hz 16:9, wide',
    labelVertex: '1080p 60Hz 16:9 normal',
  },
  {
    value: 34,
    label: '1080p 60Hz 16:9 linear',
    labelFoxeer: '1080p 60Hz 16:9, narrow',
    labelVertex: '1080p 60Hz 16:9 normal',
  },
  {
    value: 36,
    label: '1080p 60Hz 16:9 superview',
    labelFoxeer: '1080p 60Hz 16:9, wide',
    labelVertex: '1080p 60Hz 16:9 superview',
  },
  {
    value: 38,
    label: '1080p 30Hz 16:9 wide',
    labelFoxeer: '1080p 30Hz 16:9, wide',
    labelVertex: '1080p 30Hz 16:9 normal',
  },
  {
    value: 40,
    label: '1080p 30Hz 16:9 medium',
    labelFoxeer: '1080p 30Hz 16:9, narrow',
    labelVertex: '1080p 30Hz 16:9 normal',
  },
  {
    value: 42,
    label: '1080p 30Hz 16:9 narrow',
    labelFoxeer: '1080p 30Hz 16:9, narrow',
    labelVertex: '1080p 30Hz 16:9 normal',
  },
  {
    value: 44,
    label: '1080p 30Hz 16:9 linear',
    labelFoxeer: '1080p 30Hz 16:9, narrow',
    labelVertex: '1080p 30Hz 16:9 normal',
  },
  {
    value: 46,
    label: '1080p 30Hz 16:9 superview',
    labelFoxeer: '1080p 30Hz 16:9, wide',
    labelVertex: '1080p 60Hz 16:9 superview',
  },
  {
    value: 48,
    label: '1080p 24Hz 16:9 wide',
    labelFoxeer: '1080p 30Hz 16:9, wide',
    labelVertex: '1080p 30Hz 16:9 normal',
  },
  {
    value: 50,
    label: '1080p 24Hz 16:9 medium',
    labelFoxeer: '1080p 30Hz 16:9, narrow',
    labelVertex: '1080p 30Hz 16:9 normal',
  },
  {
    value: 52,
    label: '1080p 24Hz 16:9 narrow',
    labelFoxeer: '1080p 30Hz 16:9, narrow',
    labelVertex: '1080p 30Hz 16:9 normal',
  },
  {
    value: 54,
    label: '1080p 24Hz 16:9 linear',
    labelFoxeer: '1080p 30Hz 16:9, narrow',
    labelVertex: '1080p 30Hz 16:9 normal',
  },
  {
    value: 56,
    label: '1080p 24Hz 16:9 superview',
    labelFoxeer: '1080p 30Hz 16:9, wide',
    labelVertex: '1080p 60Hz 16:9 superview',
  },
  {
    value: 58,
    label: '960p 100Hz 4:3 wide',
    labelFoxeer: '1280*960 120Hz 4:3, wide',
    labelVertex: '1080p 60Hz 16:9 normal',
  },
  {
    value: 60,
    label: '960p 60Hz 4:3 wide',
    labelFoxeer: '1280*960 60Hz 4:3, narrow',
    labelVertex: '1080p 60Hz 16:9 normal',
  },
  {
    value: 62,
    label: '960p 30Hz 4:3 wide',
    labelFoxeer: '1280*960 30Hz 4:3, wide',
    labelVertex: '1080p 30Hz 16:9 normal',
  },
  {
    value: 64,
    label: '720p 120Hz 16:9 wide',
    labelFoxeer: '720p 120Hz 16:9, wide',
    labelVertex: '720p 60Hz 16:9 normal',
  },
  {
    value: 66,
    label: '720p 60Hz 16:9 wide',
    labelFoxeer: '720p 60Hz 16:9',
    labelVertex: '720p 60Hz 16:9 normal',
  },
  {
    value: 68,
    label: '720p 60Hz 16:9 medium',
    labelFoxeer: '720p 60Hz 16:9, narrow',
    labelVertex: '720p 60Hz 16:9 normal',
  },
  {
    value: 70,
    label: '720p 60Hz 16:9 superview',
    labelFoxeer: '720p 60Hz 16:9, narrow',
    labelVertex: '1080p 60Hz 16:9 superview',
  },
  {
    value: 72,
    label: '720p 30Hz 16:9 wide',
    labelFoxeer: '720p 30Hz 16:9, narrow',
    labelVertex: '720p 30Hz 16:9 normal',
  },
  {
    value: 74,
    label: '720p 30Hz 16:9 medium',
    labelFoxeer: '720p 30Hz 16:9, narrow',
    labelVertex: '720p 30Hz 16:9 normal',
  },
  {
    value: 76,
    label: '720p 30Hz 16:9 superview',
    labelFoxeer: '720p 30Hz 16:9, wide',
    labelVertex: '1080p 60Hz 16:9 superview',
  },
  {
    value: 78,
    label: '4k 30Hz 16:9 wide',
    labelFoxeer: '4k 30Hz 16:9 wide',
    labelVertex: '4k 30Hz 16:9 superview',
  },
  {
    value: 80,
    label: '2k7 30Hz 4:3 wide',
    labelFoxeer: '2880*2160 30Hz 4:3 narrow',
    labelVertex: '2k7 30Hz 16:9 normal',
  },
  {
    value: 82,
    label: '2k7 30Hz 16:9 wide',
    labelFoxeer: '2560*1440 60Hz 16:9 narrow',
    labelVertex: '2k7 60Hz 16:9 normal',
  },
  {
    value: 84,
    label: '2k7 30Hz 16:9 wide',
    labelFoxeer: '2560*1440 30Hz 16:9 narrow',
    labelVertex: '2k7 30Hz 16:9 normal',
  },
  {
    value: 86,
    label: '720p 120Hz 16:9 wide',
    labelFoxeer: '720p 240Hz 16:9 narrow',
    labelVertex: '720p 60Hz 16:9 normal',
  },
  {
    value: 88,
    label: '720p 120Hz 16:9 wide',
    labelFoxeer: '720p 120Hz 16:9 narrow',
    labelVertex: '720p 60Hz 16:9 normal',
  },
  {
    value: 90,
    label: '4k 30Hz wide',
    labelFoxeer: '4k 30 superview',
    labelVertex: '4k 30Hz 16:9 superview',
  },
  {
    value: 92,
    label: '4k 30Hz wide',
    labelFoxeer: '4k 30 normal',
    labelVertex: '4k 30Hz 16:9 normal',
  },
  {
    value: 94,
    label: '2k7 30Hz wide',
    labelFoxeer: '2k7 60 superview',
    labelVertex: '2k7 60Hz 16:9 superview',
  },
  {
    value: 96,
    label: '2k7 30Hz medium',
    labelFoxeer: '2k7 60 normal',
    labelVertex: '2k7 60Hz 16:9 normal',
  },
  {
    value: 98,
    label: '2k7 30Hz medium',
    labelFoxeer: '2k7 30 normal',
    labelVertex: '2k7 30Hz 16:9 normal',
  },
  {
    value: 100,
    label: '1080p 60Hz superview',
    labelFoxeer: '1080p 60 superview',
    labelVertex: '1080p 60Hz 16:9 superview',
  },
  {
    value: 102,
    label: '1080p 60Hz wide',
    labelFoxeer: '1080p 60 normal',
    labelVertex: '1080p 60Hz 16:9 normal',
  },
  {
    value: 104,
    label: '1080p 30Hz wide',
    labelFoxeer: '1080p 30 normal',
    labelVertex: '1080p 30Hz 16:9 normal',
  },
  {
    value: 106,
    label: '720p 60Hz wide',
    labelFoxeer: '720p 60 normal',
    labelVertex: '720p 60Hz 16:9 normal',
  },
  {
    value: 108,
    label: '720p 30Hz wide',
    labelFoxeer: '720p 30 normal',
    labelVertex: '720p 30Hz 16:9 normal',
  },
];
export const photoFormats: OldCameraFormat[] = [
  {
    value: 0,
    label: '10MP 3648*2726 4:3 wide',
    labelFoxeer: '16MP 4608*3456 4:3 wide',
    labelVertex: '20 MP',
  },
  {
    value: 1,
    label: '10MP 3648*2726 4:3 linear',
    labelFoxeer: '8,3MP 3840*2160 16:9 narrow',
    labelVertex: '10 MP',
  },
  {
    value: 2,
    label: '10MP 3648*2726 4:3 wide',
    labelFoxeer: '16MP 4608*3456 4:3 wide',
    labelVertex: '20 MP',
  },
  {
    value: 3,
    label: '10MP 3648*2726 4:3 wide',
    labelFoxeer: '14MP 4352*3264 4:3 wide',
    labelVertex: '14 MP',
  },
  {
    value: 4,
    label: '10MP 3648*2726 4:3 wide',
    labelFoxeer: '12MP 4000*3000 4:3 wide',
    labelVertex: '12 MP',
  },
  {
    value: 5,
    label: '10MP 3648*2726 4:3 linear',
    labelFoxeer: '8,3MP 3840*2160 16:9 narrow',
    labelVertex: '10 MP',
  },
  {
    value: 6,
    label: '10MP 3648*2726 4:3 wide',
    labelFoxeer: '5MP 2560*1920 4:3',
    labelVertex: '10 MP',
  },
  {
    value: 7,
    label: '10MP 3648*2726 4:3 wide',
    labelFoxeer: '3MP 2048*1536 4:3',
    labelVertex: '10 MP',
  },
];
